// Maintains a small error buffer on window for SweetLink CLI / DevTools diagnostics.
type SweetLinkCliErrorEntry = {
  type?: string | null;
  message?: string | null;
  stack?: string | null;
  source?: string | null;
};

type SweetLinkCliErrorPayload = {
  type: string;
  message: string;
  stack: string | null;
  source: string | null;
  timestamp: number;
};

const MAX_BUFFER = 20;

export function pushSweetLinkCliError(entry: SweetLinkCliErrorEntry): void {
  const windowGlobal = (globalThis as typeof globalThis & { window?: Window }).window;
  if (windowGlobal === undefined) {
    return;
  }

  const payload: SweetLinkCliErrorPayload = {
    type: typeof entry.type === 'string' && entry.type.length > 0 ? entry.type : 'error',
    message: typeof entry.message === 'string' && entry.message.length > 0 ? entry.message : 'Unknown error',
    stack: typeof entry.stack === 'string' && entry.stack.length > 0 ? entry.stack : null,
    source: typeof entry.source === 'string' && entry.source.length > 0 ? entry.source : null,
    timestamp: Date.now(),
  };

  const existing = Array.isArray(windowGlobal.__sweetlinkCliErrors) ? windowGlobal.__sweetlinkCliErrors : [];
  const next = [...existing, payload].slice(-MAX_BUFFER);
  windowGlobal.__sweetlinkCliErrors = next;
}
